import { State } from "../..";
import {
  Currency,
  Product,
  ProductPrice,
} from "../../../../../graphql/operations";
import { formatDate } from "../../../../../utils/calendarUtils";
import { Text } from "../../../../Atoms/Typography";
import { isStringEmpty } from "../../validation";
import styles from "./CheckoutSummary.module.css";
import CheckoutTotal from "./CheckoutTotal";

export type CheckoutSummaryProps = {
  productId: string;
  currencyCode: Currency;
  numSeats: number;
  productPrices: ProductPrice[];
  state: State;
  privatePrice?: number;
  productName?: string;
} & Pick<Product, "availabilityType">;

export function CheckoutSummary({
  state,
  numSeats,
  productId,
  currencyCode,
  productPrices,
  privatePrice,
  productName,
  availabilityType,
  children,
}: React.PropsWithChildren<CheckoutSummaryProps>) {
  const {
    names,
    email,
    reservationDate,
    reservationTime,
    // @ts-ignore
    paymentType,
  } = state;

  return (
    <div>
      <ul>
        {productName && (
          <li className={styles.CheckoutSummaryDescription}>
            <div className={styles.CheckoutSummaryTerm}>TOUR NAME</div>
            <div className={styles.CheckoutSummaryDefinition}>
              {productName}
            </div>
          </li>
        )}
        <div className={styles.SumItemRow}>
          <div className={styles.CheckoutSummaryTerm}>
            Name{names.length === 1 ? "" : "s"}
          </div>
          <div>
            {names.map(({ givenName, familyName }, index) => (
              <div key={index}>
                <Text>
                  {givenName} {familyName}
                </Text>
              </div>
            ))}
          </div>
        </div>

        {isStringEmpty(email) ? null : (
          <li className={styles.CheckoutSummaryDescription}>
            <div className={styles.CheckoutSummaryTerm}>Email</div>
            <div className={styles.CheckoutSummaryEmail}>{email}</div>
          </li>
        )}

        <li className={styles.CheckoutSummaryDescription}>
          <div className={styles.CheckoutSummaryTerm}>
            Reservation Date / Time
          </div>
          <div className={styles.CheckoutSummaryDefinition}>
            {reservationDate !== null ? formatDate(reservationDate) : null} /{" "}
            {reservationTime !== null ? reservationTime : null}
            {numSeats > 1 && numSeats < 4 ? (
              <span className={styles.LowSeats}>{numSeats} Spots Left</span>
            ) : null}
            {numSeats === 1 ? (
              <span className={styles.LowSeats}>{numSeats} Spot Left</span>
            ) : null}
          </div>
        </li>

        {paymentType && (
          <li className={styles.CheckoutSummaryDescription}>
            <div className={styles.CheckoutSummaryTerm}>Payment Method</div>
            <div className={styles.CheckoutSummaryDefinition}>
              {paymentType}
            </div>
          </li>
        )}
      </ul>

      <div>
        <CheckoutTotal
          productId={productId}
          currencyCode={currencyCode}
          productPrices={productPrices}
          lineItems={state.details}
          couponCode={state.couponCode}
          coupon={state.coupon}
          privatePrice={privatePrice}
          availabilityType={availabilityType}
        >
          {children}
        </CheckoutTotal>
      </div>
    </div>
  );
}
